// src/pages/vendor/VendorPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

function AdminPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleOptionClick = (option) => {
    console.log(user);
    if (option === 'ObtenerTodos') {
      if (user?.id) {
        navigate(`/vendedor/${user.id}`);
      } else {
        console.error('No user ID found.');
      }
    }
    if (option === 'Agregar') {
      navigate(`/vendedor/agregar/${user.id}`);
    }
    if (option === 'Modificar') {
      navigate('/vendedor/modificar');
    }
    if (option === 'Eliminar') {
      navigate('/vendedor/eliminar');
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="container py-5">
      {/* Título */}
      <h2 className="text-center fw-bold mb-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
        Administracion de Datos <span className="text-primary">{user?.vendor_name}</span>
      </h2>

      {/* Opciones */}
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-4 g-4 justify-content-center">
        {/* Usuarios */}
        <div className="col">
          <div
            className="card shadow-sm h-100 border-0 rounded-4 text-center p-4 option-card"
            role="button"
            onClick={() => handleOptionClick('ObtenerTodos')}
          >
            <i className="bi bi-box-seam display-5 text-primary mb-3"></i>
            <h5 className="fw-bold">Usuarios</h5>
          </div>
        </div>

        {/* Agregar Producto */}
        <div className="col">
          <div
            className="card shadow-sm h-100 border-0 rounded-4 text-center p-4 option-card"
            role="button"
            onClick={() => handleOptionClick('Agregar')}
          >
            <i className="bi bi-plus-circle display-5 text-success mb-3"></i>
            <h5 className="fw-bold">Ver Usuarios</h5>
          </div>
        </div>

        {/* Modificar Producto */}
        <div className="col">
          <div
            className="card shadow-sm h-100 border-0 rounded-4 text-center p-4 option-card"
            role="button"
            onClick={() => handleOptionClick('Modificar')}
          >
            <i className="bi bi-pencil-square display-5 text-warning mb-3"></i>
            <h5 className="fw-bold">Modificar Producto</h5>
          </div>
        </div>

        {/* Eliminar Producto */}
        <div className="col">
          <div
            className="card shadow-sm h-100 border-0 rounded-4 text-center p-4 option-card"
            role="button"
            onClick={() => handleOptionClick('Eliminar')}
          >
            <i className="bi bi-trash display-5 text-danger mb-3"></i>
            <h5 className="fw-bold">Eliminar Producto</h5>
          </div>
        </div>
      </div>

      {/* Botón de logout */}
      <div className="text-center mt-5">
        <button
          className="btn btn-outline-danger px-5 py-2 rounded-pill shadow-sm"
          onClick={handleLogout}
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          <i className="bi bi-box-arrow-right me-2"></i> Cerrar sesión
        </button>
      </div>
    </div>
  );
}

export default AdminPage;
